import React, { Component } from 'react'
import Header from "../../components/Header/Header";
import Navigation from "../../components/Navigation/Navigation";
import './SearchResult.css'
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { Field, reduxForm, getFormValues, change, formValueSelector, reset } from 'redux-form';
import { searchPolicyResult } from "../../actions/policies";
import api from "../../api/index";

import FaFileTextO from 'react-icons/lib/fa/file-text-o'
import FaChevronRight from 'react-icons/lib/fa/chevron-right'
import FaAutomobile from 'react-icons/lib/fa/automobile'
import FaCalendar from 'react-icons/lib/fa/calendar'
import FaFilePdfO from 'react-icons/lib/fa/file-pdf-o'
import SearchResultInputField from "./search-result-input-field/SearchResultInputField";
import * as moment from 'moment';
import Footer from '../../components/Footer'
import queryString from 'query-string'

function submit(values) { }
const validate = values => {
    const errors = {};
    // if(!values.policyId){
    //     errors.policyId = "fillInput"
    // }

    if (values.policyId && (/[^a-z0-9]/i.test(values.policyId))) {
        errors.policyId = "inputInEnglish"
    }

    if (values.policyId && values.policyId.length > 10) {
        errors.policyId = 'max10Symbols';
    }

    // if(!values.vinCode){
    //     errors.vinCode = "fillInput"
    // }

    // if (values.vinCode && values.vinCode !== values.vinCode.toUpperCase()) {
    //     errors.vinCode = 'InputOnlyUppercase';
    // }

    if (values.vinCode && (/[^a-z0-9]/i.test(values.vinCode))) {
        errors.vinCode = "inputInEnglish"
    }

    if (values.vinCode && values.vinCode.length > 20) {
        errors.vinCode = 'max20Symbols';
    }

    // if(!values.chassisNumber){
    //     errors.chassisNumber = "fillInput"
    // }

    // if (values.chassisNumber && values.chassisNumber !== values.chassisNumber.toUpperCase()) {
    //     errors.chassisNumber = 'InputOnlyUppercase';
    // }

    if (values.chassisNumber && (/[^a-z0-9]/i.test(values.chassisNumber))) {
        errors.chassisNumber = "inputInEnglish"
    }

    if (values.chassisNumber && values.chassisNumber.length > 20) {
        errors.chassisNumber = 'max20Symbols';
    }

    // if(!values.vehicleRegistrationNumber){
    //     errors.vehicleRegistrationNumber = "fillInput"
    // }
    if ((values.vinCode || values.chassisNumber || values.policyId) && !values.vehicleRegistrationNumber) {
        errors.vehicleRegistrationNumber = "fillRegistrationNumber"
    }

    // if (values.vehicleRegistrationNumber && values.vehicleRegistrationNumber !== values.vehicleRegistrationNumber.toUpperCase()) {
    //     errors.vehicleRegistrationNumber = 'InputOnlyUppercase';
    // }

    if (values.vehicleRegistrationNumber && (/[^a-z0-9]/i.test(values.vehicleRegistrationNumber))) {
        errors.vehicleRegistrationNumber = "inputInEnglish"
    }

    if (values.vehicleRegistrationNumber && values.vehicleRegistrationNumber.length > 20) {
        errors.vehicleRegistrationNumber = 'max20Symbols';
    }

    if (values.vehicleRegistrationNumber && (!values.vinCode && !values.chassisNumber && !values.policyId)) {
        errors.vehicleRegistrationNumber = 'insertOneMoreField';
    }

    if (!values.vehicleRegistrationNumber && !values.vinCode && !values.chassisNumber && !values.policyId) {
        errors.policyId = "insertFields";
    }

    return errors
}

class SearchResult extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dropDown: false,
            policySearchStatus: '',
            statuses: {
                active: "A",
                inactive: "I",
                Expired: "E"
            }
        }
    }

    onSearchPolicy = () => {
        let value = this.props.SearchPolicyFormResult
        let data = []
        this.props.dispatch(searchPolicyResult(data));
        if (value) {
            let ob = {
                vinCode: value.vinCode ? value.vinCode.toUpperCase() : '',
                chassisNumber: value.chassisNumber ? value.chassisNumber.toUpperCase() : '',
                registrationNumber: value.vehicleRegistrationNumber ? value.vehicleRegistrationNumber.toUpperCase() : '',
                policyNumber: value.policyId ? value.policyId.toUpperCase() : ''
            }
            if ((value.vinCode && value.vehicleRegistrationNumber) || (value.chassisNumber && value.vehicleRegistrationNumber) ||
                (value.policyId && value.vehicleRegistrationNumber)) {
                this.props.history.push(`/${this.props.currentLocale.code}/searchResult?pi=` + ob.policyNumber + `&vin=` + ob.vinCode + `&cN=` + ob.chassisNumber + `&vrn=` + ob.registrationNumber);
                api.policy.findPolicy(ob).then(({ data }) => {
                    if (data.length) {
                        this.setState({
                            result: true,
                            policySearchStatus: ''
                        })
                        if (data.length) {
                            this.props.dispatch(searchPolicyResult(data));
                        }
                    } else {
                        this.setState({
                            policySearchStatus: 'noData'
                        });
                    }

                })
            }
        }
    }

    componentWillUnmount() {
        this.props.dispatch(reset('SearchPolicyFormResult'));
    }

    handleDropdown = (e) => {
        const itembottom = e.target.parentNode.children[2];
        const searchResultDropdown = e.target;
        itembottom.classList.toggle('bottom-item-height')
        searchResultDropdown.classList.toggle('arrowdeg')
    }

    handlePolicyStatus = (status) => {
        if (status.policyActiveStatus === this.state.statuses.active) {
            return <h4 className="result-item-top-text" >{this.props.translate('activePolicy')}</h4>
        } else if (status.policyActiveStatus === this.state.statuses.inactive) {
            if (status.inactiveStatus === this.state.statuses.Expired) {
                return <h4 style={{ color: '#cccccc' }} className="result-item-top-text" >{this.props.translate('policyExpired')}</h4>
            }
            else {
                return <h4 style={{ color: '#cccccc' }} className="result-item-top-text" >{this.props.translate('notActivePolicy')}</h4>
            }
        }
    }

    handleDate = (date) => {
        let dateString = new Date(date).toUTCString();
        dateString = dateString.split(' ').slice(1, 4).join(' ')
        return dateString
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        let queryObj = queryString.parse(this.props.location.search)
        var parsedQueryObj = {}
        Object.keys(queryObj).forEach(function (key) {
            if (queryObj[key] !== "") {
                parsedQueryObj[key] = queryObj[key];
            }
        });

        let value = parsedQueryObj
        let data = []
        this.props.dispatch(searchPolicyResult(data));
        if (value) {
            let ob = {
                vinCode: value.vin ? value.vin : '',
                chassisNumber: value.cN ? value.cN : '',
                registrationNumber: value.vrn ? value.vrn : '',
                policyNumber: value.pi ? value.pi : ''
            }

            api.policy.findPolicy(ob).then(({ data }) => {
                this.setState({
                    result: true
                })
                if (data.length) {
                    this.props.dispatch(searchPolicyResult(data));
                }
            })
        }

        this.props.dispatch(change('SearchPolicyFormResult', 'policyId', parsedQueryObj.pi));
        this.props.dispatch(change('SearchPolicyFormResult', 'vinCode', parsedQueryObj.vin));
        this.props.dispatch(change('SearchPolicyFormResult', 'chassisNumber', parsedQueryObj.cN));
        this.props.dispatch(change('SearchPolicyFormResult', 'vehicleRegistrationNumber', parsedQueryObj.vrn));
    }

    render() {
        const { translate, savePolicyResult, handleSubmit, SearchPolicyFormResult, } = this.props;
        return (
            <div>
                <div className="Head">
                    <Header />
                    <Navigation />
                </div>
                <div className="paddingSeparator"></div>
                <div className="SearchParams">
                    <div className="SearchParamsContent">
                        <h3>{translate('searchParams')}</h3>
                        <div className="SearchParamItems">
                            <form onSubmit={handleSubmit} className="SearchParamItemsForm">
                                <Field name="policyId" labelName={"policyId"} uppercase={true} component={SearchResultInputField} id={111112} placeholder={""} type="text" />
                                <Field name="vinCode" labelName={"vinCode"} uppercase={true} component={SearchResultInputField} id={111114} placeholder={""} type="text" />
                                <Field name="chassisNumber" labelName={"chassisNumber"} uppercase={true} component={SearchResultInputField} id={111113} placeholder={""} type="text" />
                                <Field name="vehicleRegistrationNumber" labelName={"vehicleRegistrationNumber"} uppercase={true} component={SearchResultInputField} id={111115} placeholder={""} type="text" />
                                <button className="policy-search-btn-on-page" onClick={this.onSearchPolicy}>{translate('search')}</button>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="policySearchResultContainer">
                    {
                        this.state.policySearchStatus ? <div class="error-text searchNoResultErr">
                            {translate("noFiendPolicy")}</div> : ''
                    }

                    {savePolicyResult && savePolicyResult.map((item, index) => {
                        return (
                            <div className="policy-search-result-item" key={index} >

                                <div className="policy-result-item-top">
                                    <div className="result-item-top">
                                        <div className="result-item-icon">
                                            <FaFileTextO />
                                        </div>
                                        <div className="result-text">
                                            <h4 className="result-item-top-text green">{item.policyNumber}</h4>
                                            <h4 className="result-item-top-text">{item.vehicleRegistrationNumber}</h4>
                                        </div>
                                    </div>
                                    <div className="result-item-top">
                                        <div className="result-text">
                                            {item.insurerName && (<h4 className="result-item-top-text green" >{item.insurerName} {item.insurerLastname}</h4>)}
                                            {item.insurerTitle && (<h4 className="result-item-top-text green" >{item.insurerTitle} </h4>)}
                                            <h4 className="result-item-top-text" >{item.insurerIdentificationNumber}</h4>
                                        </div>
                                    </div>
                                    <div className="result-item-top searchStatusitem">
                                        <div className="result-text">
                                            {this.handlePolicyStatus(item)}
                                            <h4 className="result-item-top-text stay-day" >
                                                {
                                                    item.policyActiveStatus === "A" ?
                                                        translate('left') + " " + item.left + translate('day') :

                                                        item.inactiveStatus === "F" ?
                                                            translate('willBeActive') + " " + moment(item.startDate).format('DD MMM YYYY') :
                                                            ""
                                                    // item.inactiveStatus ==="E" ?
                                                    //     translate('expired') +" "+ moment(item.endDate).format('DD MMM YYYY')  : ''
                                                }

                                            </h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="searchResultDropdown" id="searchResultDropdown" onClick={e => this.handleDropdown(e)}>
                                    <div className="noPointerEvents">
                                        <FaChevronRight />
                                    </div>
                                </div>
                                <div className="policy-result-item-bottom" id="policy-result-item-bottom">
                                    <div className="policy-result-bottom-content">
                                        <div className="result-item resultItemVehicle">
                                            <div className="searchVehicleContent">
                                                <div className="result-item-icon">
                                                    <FaAutomobile />
                                                </div>
                                                <h4 className="searchVehicle" >{translate(item.vehicleCategoryNumber)}</h4>
                                            </div>
                                            <div className="searchVehicleContentText">
                                                <div className="car-model-mark">
                                                    <h4 className="searchVehicleContentText-item">{item.vehicleManufacturer} / {item.vehicleModel}</h4>
                                                </div>
                                                <h4 className="searchVehicleContentText-item" >{item.vehicleRegistrationNumber}</h4>
                                                <h4 className="searchVehicleContentText-item searchVinRegistCode" >{item.vinCode}</h4>
                                            </div>
                                        </div>
                                        <div className="result-item result-item-price">
                                            <div className="result-price-item-content">
                                                <div className="result-text">
                                                    <div className="searchResultPrice">
                                                        <h4 className="policy-search-result-value searchResultPremium">{item.premium}</h4>
                                                        <h4 className="searchResultPremium-lari">₾</h4>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="SearchitemPriceText">
                                                <h4>{translate('buyDate')}</h4>
                                                <div className="SearchitemCalendarIcon">
                                                    <FaCalendar /><h4> {moment(item.issueDate).format('DD MMM YYYY')}</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="result-item">
                                            <div className="result-text searchDate">
                                                <p className="result-text-name">{translate('active')} {translate('period')}</p>
                                                <div>
                                                    <div className="SearchitemCalendarIcon">
                                                        <FaCalendar /><h4>{moment(item.startDate).format('DD MMM YYYY')}</h4>
                                                    </div>
                                                    <div className="SearchitemCalendarIcon">
                                                        <FaCalendar /> <h4 >{moment(item.endDate).format('DD MMM YYYY')} </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="search-result-buttons">
                                        {item.documents.map(attachment => {
                                            return (<a className="search-result-btn"
                                                href={attachment.url}
                                                target="_blank"
                                                key={attachment.documentId}><FaFilePdfO /><p>{translate(attachment.documentTypeId)}</p></a>)

                                        })}
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    )}
                </div>
                <Footer />

            </div>
        )
    }
}


SearchResult = reduxForm({
    validate,
    onSubmit: submit,
    destroyOnUnmount: false,
    form: 'SearchPolicyFormResult', // a unique identifier for this form
})(SearchResult);
const mapStateToProps = state => ({
    translate: getTranslate(state.locale),
    savePolicyResult: state.policies.savePolicyResult,
    SearchPolicyFormResult: getFormValues('SearchPolicyFormResult')(state),
    currentLocale: getActiveLanguage(state.locale),
});
export default connect(mapStateToProps)(SearchResult)


// WEBPACK FOOTER //
// ./src/pages/SearchResult/SearchResult.js